//Custo css import
import './style.css'

import Form from 'react-bootstrap/Form';
import { EmptyArray } from '../../../domain/empty/model';

//React import
import { useEffect, useState } from 'react';

import Table from '../../molecules/tablas/view'
import NewSpendType from '../NewSpendType/view';

import { getSpendTypes } from '../../../usecases/spend-type-usecase';
import { listener } from '../../../utils/dispatch';
import { Switch } from '@mui/material';
import EditSpendType from '../EditSpendType/view';
// import EditSpendType from '../EditSpendType/view'; // Placeholder for future EditSpendType component

function SpendTypeTable({ ref, tableHeight, profile }) {

    const [spendTypes, setSpendTypes] = useState({
        total: 0,
        page: 1,
        page_size: 10,
        data: [],
    })
    const setup = setUpTable();

    useEffect(() => {
        fetchSpendTypes()
        listener('reload-spend-types', () => fetchSpendTypes(1, 10))
    }, []);

    function fetchSpendTypes(page = spendTypes.page, page_size = spendTypes.page_size) {
        setSpendTypes(prev => ({ ...prev, data: [] }))
        getSpendTypes(page, page_size).then((res) => {
            if (res.data.length === 0) {
                setSpendTypes(prev => ({ ...prev, data: EmptyArray }))
            } else {
                setSpendTypes(res)
            }
        }).catch((err) => {
            setSpendTypes(prev => ({ ...prev, data: EmptyArray }))
        })
    }

    function setUpTable() {
        return {
            headers: [
                "Nombre",
                "Es Recurrente",
                "Está Activo"
            ],
            exclude: [
                "created_at",
                "id",
                "users_id",
                "updated_at",
                "retention",
                "retention_id",
                "tax_id",
                "tax",
                "spend_ua_id"
            ],
            actions: {
                edit: true,
                delete: true
            }
        }
    }


    return (
        <Table
            id="spend-type-table"
            emptyMessage="Aun no tienes tipos de gasto"
            emptyChild={<NewSpendType id="spend-type-table" profile={profile}></NewSpendType>}
            headersList={setup ? setup.headers : []}
            paginatedData={spendTypes}
            getFunction={fetchSpendTypes}
            excludeList={setup ? setup.exclude : []}
            formats={{
                is_active: {
                    type: "custom",
                    children: (data, index) => (
                        <Switch disabled defaultChecked={data["is_active"]} />
                    )
                },
                is_recurrent: {
                    type: "custom",
                    children: (data, index) => (
                        <Switch disabled defaultChecked={data["is_recurrent"]} />
                    )
                },
            }}
            toolbarActions={<NewSpendType />}
        >
            <EditSpendType />
        </Table>
    )
}

export default SpendTypeTable;
